import React from 'react';
import LabelValue from 'utils/components/LabelValue/LabelValue';
import DetailPanel from 'widgets/supportVisualisation/Content/DetailPanel';
import { LogMessageRow } from 'widgets/supportVisualisation/Content/Messages/Messages';
import { toDateString } from 'widgets/supportVisualisation/SupportVisualisationHelpers';

export interface MessagePanelProps {
    msg: LogMessageRow;
    height: number;
    width: number;
}

export default function MessagePanel(props: MessagePanelProps) {
    const { msg, height, width } = props;

    return (
        <DetailPanel className="MessagePanel" height={height} width={width}>
            <div className="info">
                <LabelValue label="Time" value={toDateString(msg.timestamp)} />
                <LabelValue label="Level" value={msg.level} />
                <LabelValue label="Source" value={msg.source} />
                <LabelValue label="Message" value={msg.message} />
            </div>
            <div className="payload-container">
                <div className="payload">{JSON.stringify(msg.data)}</div>
            </div>
        </DetailPanel>
    );
}
